import styled from 'styled-components'

export const TabsTab = styled.div`
    padding: 8px 24px;
    text-align: center;
    position: relative;
    display: flex;
    align-items: center;
    color: rgba(0,0,0,0.88);
    cursor: pointer;
    min-width: 40px;
    border-radius: 999px;

    &:hover{
        background-color: #eeeeee;
    }

    &.tabs_tab_active{
        background-color: var(--dark-bg);
        border-radius: 999px;

        &::after {
            content: '';
            height: 6px;
            width: 6px;
            border-radius: 999px;
            position: absolute;
            left: 12px;
            background-color: #f2aa00;
        }

        .tabs-tab-btn{
            color: #ffffff;
        }
    }
`